import { X } from "lucide-react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useActivePromotion } from "@/hooks/useActivePromotion";
import { FREE_SHIPPING_COPY } from "@/lib/shipping";

const fallbackMessages = [
  { text: "First order? Use code LOFTLOOM10 for 10% off · ", link: "/best-sellers", cta: "Shop Now" },
  { text: `${FREE_SHIPPING_COPY} · `, link: "/best-sellers", cta: "Shop Now" },
  { text: "30-day returns on unused items · ", link: "/returns", cta: "Read the returns policy" },
  { text: "Free room plans, emailed within 2 business days · ", link: "/design-services", cta: "Request one" },
];

export const AnnouncementBar = () => {
  const [visible, setVisible] = useState(true);
  const [index, setIndex] = useState(0);
  const { data: promotion } = useActivePromotion();

  const messages = promotion?.announcement_text
    ? [
        { text: `${promotion.announcement_text} · `, link: "/categories", cta: "Shop Now" },
        ...fallbackMessages,
      ]
    : fallbackMessages;

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % messages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [messages.length]);

  if (!visible) return null;

  const current = messages[index];

  return (
    <div className="bg-foreground text-background">
      <div className="container flex items-center justify-center h-10 relative overflow-hidden">
        <p key={index} className="text-[13px] tracking-wide font-medium animate-fade-in">
          {current.text}
          <Link to={current.link} className="underline underline-offset-2 hover:opacity-80 transition-opacity font-medium">
            {current.cta}
          </Link>
        </p>
        {/* Full bar height and 44px wide: the bare 14px icon used to be the whole target. */}
        <button
          onClick={() => setVisible(false)}
          aria-label="Close announcement"
          className="absolute right-0 inline-flex h-10 w-11 items-center justify-center text-background/50 hover:text-background transition-colors"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};
